import { render, staticRenderFns } from "./CheckoutsList.vue?vue&type=template&id=2b95cb36&scoped=true"
import script from "./CheckoutsList.vue?vue&type=script&lang=js"
export * from "./CheckoutsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b95cb36",
  null
  
)

export default component.exports